import React from 'react';
import { Switcher } from '../switch';
import './toggle-card-section.scss';

type ToggleCardSectionProps = {
  title: string;
  checked: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
};

export const ToggleCardSection: React.FC<ToggleCardSectionProps> = ({
  title,
  checked,
  onToggle,
  children,
}) => {
  return (
    <div className="toggle-card-view">
      <div className="toggle-card-view--header">
        <Switcher
          checked={checked}
          onChange={onToggle}
          switcherStyles={{
            switchSize: { width: 34, height: 20 },
            thumbSize: { width: 14, height: 14 },
            checkedTransform: 'translateX(14px)',
            noSelectBg: '#f0f0f0',
            thumbColor: checked ? '#fff' : '#8c8c8c',
          }}
        />

        <div className="toggle-card-view--title font-semibold">{title}</div>
      </div>
      {checked && children && (
        <div className="toggle-card-view--content">{children}</div>
      )}
    </div>
  );
};
